import React, { useState, useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _get from "lodash/get";

import TermForm from "../CreateTerm/TermForm";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import propTypes from "../../../../../../constants/propTypes";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";

import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../../utils/formValidationUtils";
import { processUpdateRequestStatus } from "../../../../../../utils/dataComponentUtils";

export const dataComponentId = "TermsGrid";

const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions,
  onSuccess
) => {
  processUpdateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
      onSuccess();
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

const EditTermContainer = ({
  dataComponent,
  closeModalDialog,
  term,
  setReload,
  performUpdateRequest,
  onSuccess,
  maxPosition,
  loading,
  params,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions,
      onSuccess
    );
  });

  const handleEdit = useCallback(
    ({ displayOrder, relation, ...instance }, formikActions) => {
      performUpdateRequest(
        dataComponentId,
        term.id,
        {
          ...instance,
          displayOrder: Number(displayOrder),
          forRfq: relation.includes("RFQ"),
          forPo: relation.includes("PO"),
        },
        params
      );
      setFormikAction(formikActions);
    },
    [performUpdateRequest, term.id, params]
  );

  const initialValues = useMemo(() => {
    const { forRfq, forPo, ...values } = term;
    values.relation = [];
    if (forRfq) {
      values.relation.push("RFQ");
    }
    if (forPo) {
      values.relation.push("PO");
    }
    return values;
  }, [term]);

  const isGlobalTerm = !params?.termContext;

  return (
    <TermForm
      initialValues={initialValues}
      loading={loading}
      maxPosition={maxPosition}
      onSubmit={handleEdit}
      isUpdate
      isGlobalTerm={isGlobalTerm}
    />
  );
};

EditTermContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  term: propTypes.term,
  performUpdateRequest: PropTypes.func,
  setReload: PropTypes.func,
  onSuccess: PropTypes.func,
  maxPosition: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  params: PropTypes.shape({
    termContext: PropTypes.string,
    contextValue: PropTypes.string,
  }),
};

export const mapDispatchToProps = {
  closeModalDialog,
  performUpdateRequest,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
    loading: _get(dataComponent, "requestState.update.loading"),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTermContainer);
